import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { setInstrument } from "../../../../../../../redux/actions/canvas/canvas";
import { isSafari } from "../../../../../../../utils/browsers";
export var Microphone = function () {
    var _a = useSelector(function (state) { return state.canvas; }), instrument = _a.instrument, isMicrophoneActive = _a.isMicrophoneActive;
    var instrumentToggle = function () { return setInstrument('microphone'); };
    return (_jsx(Button, { onClick: instrumentToggle, className: clsx({
            "pi pi-microphone remove-button-text microphone-instrument": true,
            "active": instrument === 'microphone',
            "isRecord": isMicrophoneActive,
            'hidden': isSafari(),
        }) }));
};
